<template>
  <div>
    <el-row :gutter="20">
      <el-col v-for="(item, index) in bultos" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
        <div class="bultos">
          <el-card shadow="hover">
            <div slot="header">
              <span>包裹</span>
              <el-popconfirm 
                title="确定删除此包裹吗？"
                @confirm="delBultos(index)"
              >
                <el-button 
                  type="text" 
                  icon="el-icon-delete-solid"
                  style="float:right;padding: 0" 
                  slot="reference"
                />
              </el-popconfirm>
            </div>
            <div class="bultos-item">重量 <b>{{ item.kilos }} Kg</b></div>
            <div class="bultos-item">长度 <b>{{ item.largo }} Cm</b></div>
            <div class="bultos-item">宽度 <b>{{ item.ancho }} Cm</b></div>
            <div class="bultos-item">高度 <b>{{ item.alto }} Cm</b></div>
          </el-card>
        </div>
      </el-col>
      <!-- 添加 -->
      <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
        <div class="bultos" @click="openDialog">
          <el-card shadow="hover">
            <div class="bultos-add">
              <i class="el-icon-plus"></i>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <!-- 组件 -->
    <el-dialog
      title="添加包裹"
      :visible.sync="open"
      width="450px"
      center
    >
      <el-form 
        :model="data" 
        :rules="rules" 
        ref="dialog" 
        label-width="60px"
      >
        <el-form-item label="重量" prop="kilos">
          <el-input v-model="data.kilos" ref="input" clearable>
            <template slot="append">Kg</template>
          </el-input>
        </el-form-item>
        <el-form-item label="长度" prop="largo">
          <el-input v-model="data.largo" clearable>
            <template slot="append">Cm</template>
          </el-input>
        </el-form-item>
        <el-form-item label="宽度" prop="ancho">
          <el-input v-model="data.ancho" clearable>
            <template slot="append">Cm</template>
          </el-input>
        </el-form-item>
        <el-form-item label="高度" prop="alto">
          <el-input v-model="data.alto" clearable>
            <template slot="append">Cm</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="open = false">取 消</el-button>
        <el-button type="primary" @click="addBultos" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { query } from '../api/api';

export default {
  name: 'HomeBultos',
  props: {
    id: Number
  },
  data() {
    return {
      loading: false,
      bultos: [],
      data: {},
      open: false,
      rules: {
        kilos: [ { required: true, message: '请填写包裹重量', trigger: 'change' } ],
        largo: [ { required: true, message: '请填写包裹长度', trigger: 'change' } ],
        ancho: [ { required: true, message: '请填写包裹宽度', trigger: 'change' } ],
        alto: [ { required: true, message: '请填写包裹高度', trigger: 'change' } ],
      }
    }
  },
  created() {
    // 监听键盘
    document.onkeydown = (ev) => {
      const event = ev || event
      // 开始下单
      if(event.keyCode == 13){
        // 判断包裹是否打开
        if(this.open) {
          this.addBultos()
        }
      }
      // 开始下单
      if(event.keyCode == 107){
        this.openDialog()
        event.returnValue = false
      }
    }
  },
  methods: {
    openDialog() {
      // 打开窗口
      this.open = true

      this.$nextTick(function(){
        // 焦点
        this.$refs['input'].focus()
        this.$refs['dialog'].clearValidate()
        // 数据清空
        this.data = {}
      })
    },
    addBultos() {
      this.$refs['dialog'].validate((valid) => {
        if (valid) {
          // 查询包裹是否可以添加
          this.getQuery(this.data)
        } else {
          return false;
        }
      });
    },
    delBultos(index) {
      this.bultos.splice(index, 1)
      this.update()
      // 更新触发包裹变动
      this.$emit('change')
    },
    // 更新赋值
    update() {
      this.$emit('input', this.bultos)
    },
    // 查询包裹是否可以添加
    getQuery(data) {
      this.loading = true
      // 合并临时包裹
      const temp = {id: this.id, bultos: this.bultos.concat(data)}
      // 查询
      query(temp).then(res => {
        this.loading = false
        if(res.err) {
          return this.$message({
            message: res.msg,
            type: 'error'
          });
        }
        // 添加到包裹中
        this.open = false
        this.bultos.push(data)
        this.update()
        // 触发更新价格
        this.$emit('order', res)
      })
    },
  },
}
</script>